import * as types from "./types";
import { getModuleConfigListAxios } from "./services";

export async function getModuleConfigListAction({ commit }) {
  commit(types.LOADING_MODULECONFIG, true);
  try {
    console.log("Calling API: /tenants/getmoduleconfig");
    const { data } = await getModuleConfigListAxios();
    
    // Ensure correct response structure is logged
    if (data.success && data.result && Array.isArray(data.result.configs)) {
      console.log("API Response (Configs):", data.result.configs);
      commit(types.GET_MODULECONFIG_LIST, data.result.configs); // Pass only configs array
    } else {
      console.warn("Unexpected API Response Format:", data);
    }
  } catch (e) {
    console.error("Error in getModuleConfigListAction:", e);
    throw e;
  } finally {
    commit(types.LOADING_MODULECONFIG, false);
  }
}
